import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import FooterCopyrightBar from './FooterCopyrightBar';
import SocialIconGroup from './SocialIconGroup';

const Footer = () => {

    return (
      <footer className="bg-gray-900 border-t border-gray-700">
        <div className="container bottom-0 left-0 right-0 mx-auto">
          <div className="py-4 px-6 text-center">
                <div className="px-6">
                  <div className='flex justify-center mb-4'>
                    <Link to='/'>
                        <img
                        className="h-16 w-auto lg:block my-4"
                        src={process.env.PUBLIC_URL + '/static/img/meted_logo_xl.png'}
                        alt="COMET MetEd - Education and Training"
                        />
                    </Link>
                  </div>
                  <p className="max-w-lg mt-1 text-gray-300 text-sm mx-auto">
                    <FormattedMessage id='footer.meted_blurb' defaultMessage="MetEd is operated by The COMET® Program, a talented team of
                    scientists, instructional designers, and developers. We've
                    been producing quality educational materials since 1989." />
                  </p>
                  <SocialIconGroup />
                  
                </div>

                <div className="mt-8 text-center">
                    <p className='text-gray-300 text-sm mb-2'>
                      <FormattedMessage id='footer.part_of_ucp' defaultMessage="COMET and MetEd are proud to be a part of" /> <a href="http://www.ucp.ucar.edu/"><FormattedMessage id='footer.ucp' defaultMessage="UCAR Community Programs" /></a>.</p>    
                    <div className='flex justify-center'>
                        <a href="http://www.ucp.ucar.edu/"><img src="/images/footer_ucp_logo.jpg" alt="UCP Logo" /></a>
                    </div>
                </div>

          </div>
        </div>
        <FooterCopyrightBar />
      </footer>
    );
};

export default Footer;